



















































import { Component, Vue, Mixins, Watch, Ref } from 'vue-property-decorator';
import GlobalFnMixin from '@/util/mixins';
import Table from '@/components/Table/index.vue'
import MessageDetail from './components/MessageDetail.vue';
import { Action } from 'vuex-class';
import R from '@/service/message';

@Component({
  components: {
    MessageDetail,
    Table,
  }
})
export default class MessageCenter extends Mixins(GlobalFnMixin) {
  @Action('message/clearMessageNumber')
  clearMessageNumber;
  @Ref('messageTablRef')
  messageTablRef!: Table;

  tableData: any = [];
  totalTableDataSize = null;
  loading = false;
  pageSet = {
    pageNo: 0,
    pageSize: 10,
  };
  tableSelections = [];

  get currentPage() {
    return this.pageSet.pageNo + 1;
  }

  get isIndeterminate() {
    const selectedNum = this.tableSelections.length;
    const tableDataNum = this.tableData.length;
    return selectedNum > 0 && selectedNum < tableDataNum;
  }

  get isAllLibSelected() {
    const selectedNum = this.tableSelections.length;
    const tableDataNum = this.tableData.length;
    if (selectedNum > 0 && tableDataNum === selectedNum) {
      return true;
    } else {
      return false;
    }
  }

  mounted() {
    this.fetchList();
  }

  async batchDelete() {
    try {
      await this.ropConfirm(
        '确定删除吗',
        '删除后所选消息将被移除',
      );
    } catch (err) {
      return;
    }
    const params = this.tableSelections.map(i => i.id);
    try {
      await this.pendingRequest('loading', () => R.batchDeleteMessage(params));
      this.$message.success('删除成功');
      this.fetchList();
    } catch (err) {
      this.$message.error(err.message)
    }
  }

  toggleAllLibSelected(val) {
    if (this.tableData.length === 0) {
      return;
    }
    this.messageTablRef.tableEl.toggleAllSelection();
  }

  async fetchList() {
    this.clearMessageNumber();
    const params = {
      ...this.pageSet,
    };
    try {
      const {
        content,
        numberOfElements,
        totalElements,
      } = await this.pendingRequest('loading', () => R.fetchMessageList(params));
      this.tableData = content;
      this.totalTableDataSize = totalElements;

      if (totalElements > 0 && numberOfElements === 0) {
        this.pageSet.pageNo = 0;
        this.fetchList();
      }
    } catch (err) {
      this.$message.error(err.message);
    }
  }

  onPageChange(page) {
    this.pageSet.pageNo = page - 1;
    this.fetchList();
  }

  handleSelectionChange(val) {
    this.tableSelections = val;
  }

}
